var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHiwThumb = function SvgHiwThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.964 98.695"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 130"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 108"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 82"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 97",
    d: "M103.922 1.197a1.7 1.7 0 0 0-2.3.728L95.1 14.513H34.923a33.922 33.922 0 1 0 0 67.845H59.95l-6.653 12.843a1.706 1.706 0 0 0 3.028 1.571l7.469-14.414 35.151-67.845 5.706-11.016a1.706 1.706 0 0 0-.729-2.3ZM61.713 78.951h-26.79a30.514 30.514 0 0 1 0-61.028h58.413Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 124",
    d: "m23.574 19.101 20.7-2.648 24.017.807 26.508-.807-7.146 18.927-13.391 24.89-12.4 21.412H51.817L29.67 80.008l-12.986-6.134L6.109 61.257 2.121 47.83l2.381-10.913 7.512-11.571Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 112"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 49"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 110",
    d: "M55.142 66.231H42.393a15.374 15.374 0 0 1-7.038-1.541c-2.471-1.061-5.546-2.38-14.533-2.38a.981.981 0 0 1-.981-.981V43.68a.981.981 0 0 1 .981-.98h5.883c6.493 0 13.727-6.04 13.727-14.708a3.242 3.242 0 0 1 3.422-3.2 4.112 4.112 0 0 1 3.061 1.4 6.186 6.186 0 0 1 1.361 4.183 54.327 54.327 0 0 1-1.682 10.356h14.429a39.314 39.314 0 0 0 1.961 9.8 3.919 3.919 0 0 0-1.961 5.883 3.919 3.919 0 0 0-1.961 5.883 3.926 3.926 0 0 1-3.92 3.934Zm-33.337-5.877c8.642.094 11.786 1.443 14.327 2.533a13.384 13.384 0 0 0 6.263 1.383h12.747a1.961 1.961 0 0 0 0-3.922.981.981 0 1 1 0-1.961h1.961a1.961 1.961 0 0 0 0-3.922.98.98 0 1 1 0-1.961h1.961a1.961 1.961 0 1 0 0-3.922.981.981 0 1 1 0-1.961h1.961a1.961 1.961 0 1 0 0-3.922h-15.69a.98.98 0 0 1-.947-1.232c.018-.073 1.928-7.338 1.928-11.085a4.3 4.3 0 0 0-.867-2.881 2.109 2.109 0 0 0-1.594-.745 1.314 1.314 0 0 0-1.461 1.235c0 9.823-8.267 16.668-15.688 16.668h-4.9Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }))))));
};
export default SvgHiwThumb;